import { APIClient } from "../api";
import axios, { AxiosAdapter } from 'axios';
export default class BusinessUnitService extends APIClient {

    async GetDataBaseType() {
        const url = `${this.endpoint}/GetDataBaseType`;
        
        if (typeof this.cancelToken != typeof undefined) {
            this.cancelToken.cancel("Operation canceled due to new request.")
        }

        //Save the cancel token for the current request
        this.cancelToken = axios.CancelToken.source();
        return this.api({
            method: 'get',
            url,
            cancelToken: this.cancelToken.token
        });
    }
}